import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';

interface AccountPopoverProps {
  onLogout: () => void;
}

export const AccountPopover: React.FC<AccountPopoverProps> = (props) => {
  const { onLogout } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const goToAccount = useCallback(() => {
    setOpen(false);
    history.push('/mon-compte');
  }, [history]);

  const handleLogout = useCallback(() => {
    setOpen(false);
    onLogout();
  }, [onLogout]);

  return (
    <Popover
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      color="#FFF"
      rootClassName="no-padding-popover white-popover"
      content={
        <div className="flex flex-col items-start py-1" role="menu">
          <Button type="text" role="menuitem" onClick={goToAccount}>
            {t('navigation:mon_compte')}
          </Button>
          <Button type="text" danger role="menuitem" onClick={handleLogout}>
            {t('global:logout')}
          </Button>
        </div>
      }
    >
      <Button
        type="text"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={t('navigation:mon_compte')}
        className="flex items-center gap-1 !px-2 !h-10"
      >
        <UserOutlined className="text-xl text-gris-hellio" />
        <DownOutlined className="text-xs text-gris-hellio" />
      </Button>
    </Popover>
  );
};

export default AccountPopover;
